import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"
import { setThumbTable, initializeItems } from "./slice"

import ThumbTableView from "./components/ThumbTableView"
import { Collection } from "../../models"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (
        element: HTMLElement | undefined | null,
        collection: Collection,
    ) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (
        element: HTMLElement | undefined | null,
        collection: Collection,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        store.dispatch(setThumbTable(collection))
        store.dispatch(initializeItems())

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <OldUIContext.Consumer>
                        {(): JSX.Element => <ThumbTableView />}
                    </OldUIContext.Consumer>
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    return {
        start,
    }
}

export default init
